export default __webpack_public_path__ + "static/media/lamictal.e477b209.jpg";